//==============================
// Global
//==============================

FastClick.attach(document.body);

$.Scrollax();

/*
$('.element').waypoint(function(direction) {
  var thisElement = $(this.element);
  //stuff
  this.destroy();
}, {
  offset: '50%'
});
*/

// $('.thing-with-videos').fitVids();
